module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-page"
  }, [_c('div', {
    staticClass: "search-bar"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "cancel",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-bar"
  }, [_c('i', {
    staticClass: "fa fa-search isearch",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "autofocus": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-kind"
  }, [_c('a', {
    staticClass: "s-kind s-text"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "s-title"
  }, [_vm._v("文本")])]), _vm._v(" "), _c('a', {
    staticClass: "s-kind s-image"
  }, [_c('i', {
    staticClass: "fa fa-picture-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "s-title"
  }, [_vm._v("图片")])]), _vm._v(" "), _c('a', {
    staticClass: "s-kind s-audio"
  }, [_c('i', {
    staticClass: "fa fa-microphone",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "s-title"
  }, [_vm._v("语音")])]), _vm._v(" "), _c('a', {
    staticClass: "s-kind s-web"
  }, [_c('i', {
    staticClass: "fa fa-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "s-title"
  }, [_vm._v("网页")])]), _vm._v(" "), _c('a', {
    staticClass: "s-kind s-card"
  }, [_c('i', {
    staticClass: "fa fa-list-alt",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "s-title"
  }, [_vm._v("卡组")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "split-line"
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('span', [_vm._v("所有标签")]), _vm._v(" "), _c('div', {
    staticClass: "line"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all-tags"
  }, [_c('span', [_vm._v("#示例卡片")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36198a8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search.vue
// module id = 51
// module chunks = 0